import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';

import { BaseApi } from '../../base.api';
import { BrandNotFoundError } from './error/brand-not-found-error';
// eslint-disable-next-line import/namespace
import { errorCodes } from './error/error-codes';
import { Brand } from './model/brand';

@Injectable()
export class BrandingApi extends BaseApi {
  getBranding(): Observable<Brand> {
    const url = this.baseUrl + `/branding-public`;

    return this.httpClient.get<Brand>(url).pipe(
      catchError((err: unknown) => {
        if (err instanceof HttpErrorResponse) {
          const errorCode = err.error.code;

          if (errorCode === errorCodes.BRAND_NOT_FOUND) {
            return throwError(() => new BrandNotFoundError());
          }
        }

        return throwError(() => err);
      }),
    );
  }
}
